import { Injectable } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { AppContextSelector, CoreHttpClient, ProductType } from "@obg/ngx.core";
import { CoreContentState } from "@obg/ngx.core.content";
import { ignoreNil } from "@obg/ngx.global";
import { camelCase, orderBy, upperFirst } from "lodash-es";
import { Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";

import { GameCollection } from "../../game-collection/game-collection.model";
import { GameCollectionSelector } from "../../game-collection/game-collection.selector";
import { GamingExternalState } from "../../state";

import { RecommendedGamesConfigService } from "./recommended-games.config";
import { RECOMMENDED_GAMES_COLLECTION_IDS } from "./recommended-games.const";
import { RecommendedGamesResponse } from "./recommended-games.model";

@Injectable({
	providedIn: "root",
})
export class RecommendedGamesService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: RecommendedGamesConfigService,
		private store: Store<GamingExternalState & CoreContentState>,
		private gameCollectionSelector: GameCollectionSelector
	) {}

	getAll(): Observable<string[]> {
		return this.httpClient
			.get<RecommendedGamesResponse[]>({
				url: this.config.getAllEndpoint(),
				headers: { "Cache-Control": "no-cache" },
			})
			.pipe(map((games) => orderBy(games, ["rank"], "asc").map((g) => g.gameId)));
	}

	getRecommendedGamesCollectionOrder$(): Observable<number | null> {
		// If observable emits null, then we don't fetch the recommended games
		const product$: any = this.store.select(AppContextSelector.getProduct).pipe(
			ignoreNil(),
			map((productType: ProductType) => productType)
		);

		return product$.pipe(
			switchMap((productType: ProductType) =>
				this.store.pipe(
					select(this.gameCollectionSelector.getSubCollectionsById(upperFirst(camelCase(productType)))),
					map((collections: GameCollection[]) => {
						const recommendedGames = collections?.find(
							(collection: GameCollection) =>
								collection.id === RECOMMENDED_GAMES_COLLECTION_IDS[productType]
						);
						return recommendedGames ? recommendedGames.sortOrder : null;
					})
				)
			)
			// dont add ignoreNil() here, as it will break game-carousel-wrapper collection creation
		);
	}
}
